import React, { useState } from "react";
import "./injectionPriceTemplate.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
export default function InjectionPriceTemplate(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);

  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderInput = (name, type = "text", size) => (
    <>
      <input
        type={type}
        name={name}
        className={`createTime ${show ? "hide" : "show"}`}
        onChange={handleChange}
        style={{ width: size }}
      />
      <span className={`bookinginput ${!show ? "hide" : "show"}`}>
        &nbsp;{formData[name]}
      </span>
    </>
  );
  const renderSelect = (name, options, size) => (
    <>
      <select
        name={name}
        className={`createTime ${show ? "hide" : "show"}`}
        onChange={handleChange}
        style={{ border: "1px solid black", width: size }}
      >
        <option disabled selected>
          select
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span
        style={{ fontWeight: "400" }}
        className={`bookinginput ${!show ? "hide" : "show"}`}
      >
        &nbsp;{formData[name]}
      </span>
    </>
  );
  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <th style={style}>{value}</th>;
  };
  const renderIndentation = () => (
    <span
      style={{
        visibility: "hidden",
        fontSize: "30px",
        lineHeight: "20px",
      }}
    >
      ●
    </span>
  );
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: "30px",
        // lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        height: "20px",
      }}
    >
      ●
    </span>
  );

  const handlesubmit = () => {
    props.loaderchange("true");

    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "ET Template",
            },
          };
          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");

          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="EtTemplate">
      <div className="EtTemplate">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          <div className="detail"></div>
        </div>
        <div className="detail">
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                {renderTableTH("Medicine/Dose")}
                {[75, 150, 225, 300, 375, 450, 1200].map((ele) =>
                  renderTableTH(ele)
                )}
              </tr>
              <tr>
                {renderTableTH("Follisurge MDV")}
                {[1735, 3465, 5200, 6930, 8665, 10395, 27720].map((ele) =>
                  renderTableTD(ele)
                )}
              </tr>
              <tr>
                {renderTableTH("MENOTAS XP")}
                {[1335, 2670, 4000, 5335, 6670, 8005, 21340].map((ele) =>
                  renderTableTD(ele)
                )}
              </tr>
              <tr>
                {renderTableTH("SETROSIL")}
                {[1500, ...Array(6)].map((ele) => renderTableTD(ele))}
              </tr>
              <tr>
                {renderTableTH("PERGOVERIS")}
                {[2098, 5817, 8725, 11635, 14545, 17450, ""].map((ele) =>
                  renderTableTD(ele)
                )}
              </tr>
            </tbody>
          </table>
        </div>
        <div className="detail">
          <div>
            <h3 style={{ textAlign: "center" }}>STANDARD DOSAGE PACKAGES</h3>
          </div>
          <table style={{ width: "100%" }}>
            <tbody>
             
                {[
                  "FOLLISURGE 225 + MENOTAS XP 150",
                  "FOLLISURGE 225+MENOTAS 150+SETROSIL",
                  "FOLLISURGE 225 + MENOTAS XP 75",
                  "FOLLISURGE 225 + MENOTAS XP 75+SETROSIL",
                  "FOLLISURGE 150 + MENOTAS XP 150",
                  "FOLLISURGE 150 + MENOTAS XP 150+SETROSIL",
                ].map((ele,ind)=>{
                    const price = [7870,9370,6535,8035,6135,7635]
                    return(
                        <tr key={ind}>
                            {renderTableTH(ele)}
                            {renderTableTH(price[ind])}
                        </tr>
                    )
                })}
            
            </tbody>
          </table>
        </div>
        <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          
          
          <div>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                {renderTableTH("Medicine/Dose")}
                {[75, 150, 225, 300, 375, 450, 1200].map((ele) =>
                  renderTableTH(ele)
                )}
              </tr>
              <tr>
                {renderTableTH("Follisurge MDV")}
                {[1735, 3465, 5200, 6930, 8665, 10395, 27720].map((ele) =>
                  renderTableTD(ele)
                )}
              </tr>
              <tr>
                {renderTableTH("MENOTAS XP")}
                {[1335, 2670, 4000, 5335, 6670, 8005, 21340].map((ele) =>
                  renderTableTD(ele)
                )}
              </tr>
              <tr>
                {renderTableTH("SETROSIL")}
                {[1500, ...Array(6)].map((ele) => renderTableTD(ele))}
              </tr>
              <tr>
                {renderTableTH("PERGOVERIS")}
                {[2098, 5817, 8725, 11635, 14545, 17450, ""].map((ele) =>
                  renderTableTD(ele)
                )}
              </tr>
            </tbody>
          </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4>STANDARD DOSAGE PACKAGES</h4>
          </div>
                <div>
                <table style={{ width: "100%" }}>
            <tbody>
             
                {[
                  "FOLLISURGE 225 + MENOTAS XP 150",
                  "FOLLISURGE 225+MENOTAS 150+SETROSIL",
                  "FOLLISURGE 225 + MENOTAS XP 75",
                  "FOLLISURGE 225 + MENOTAS XP 75+SETROSIL",
                  "FOLLISURGE 150 + MENOTAS XP 150",
                  "FOLLISURGE 150 + MENOTAS XP 150+SETROSIL",
                ].map((ele,ind)=>{
                    const price = [7870,9370,6535,8035,6135,7635]
                    return(
                        <tr key={ind}>
                            {renderTableTH(ele)}
                            {renderTableTH(price[ind])}
                        </tr>
                    )
                })}
            
            </tbody>
          </table>
                </div>
                <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment",appointmentData.date?.split("-").reverse().join("-"))}
</div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
